/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseTextClassification = dynamic(
  () => import('../tasks/TaskResponseTextClassification'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const instruction = 'What is the sentiment of this review?';

export const responseCode = `{
  "response": {
    "taxonomies": {
      "sentiment": ['Positive']
    }
  }
  "task_id": '5795c68afce306120434be64',
  "task": { ... }
}`;

export const code = `client.*createCategorizationTask*({
  callback_url: 'http://www.example.com/callback',
  instruction: '${instruction}',
  params: {
    t_type: 'image',
    attachment: 'beats-headphones-review.png',
    taxonomies: {
      sentiment: {
        type: 'category',
        description: '${instruction}',
        choices: ['Negative', 'Neutral', 'Positive'],
      }
    }
  },
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseTextClassification />;

export const result = <TaskResponseTextClassification animate />;
